import { useEffect, useRef } from "react";

export default function CookiebotDeclaration() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) return () => {};

    const script = document.createElement('script');
    script.setAttribute('id', 'CookieDeclaration');
    script.setAttribute('src', 'https://consent.cookiebot.com/590a5817-d626-498d-a267-3f850637ae72/cd.js');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('async', 'true');
    ref.current?.append(script);

    return () => {}
  }, [])

  return <div ref={ref} />
}
